import { render, staticRenderFns } from "./MassEmailsForm.vue?vue&type=template&id=507583a7&scoped=true"
import script from "./MassEmailsForm.vue?vue&type=script&lang=js"
export * from "./MassEmailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507583a7",
  null
  
)

export default component.exports